import { Button, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import { Link, useRecordContext } from "react-admin";
import { Controller, useForm } from "react-hook-form";
import CustomProductTextField from "../../unit/forms/CustomProductTextField";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import CustomProductActionBottom from "../CustomProductActionBottom";
export default function DescriptionEn({
  onSave,
  defaultValues,
  ...props
}: any) {
  let selectLanguage = props?.selectLanguage || "english";

  const [activeTab, setActiveTab] = React.useState(0);
  const record = useRecordContext();
  const basicData = record?.data?.basic;
  const data = record?.data?.basic?.description;
  // console.log("Description record:", data);
  const {
    control,
    getValues,
    formState: { errors, isDirty },
    reset,
  } = useForm({
    mode: "onBlur",
    defaultValues: defaultValues || {
      productname_en: "",
      description_en: "",
    },
  });
  React.useEffect(() => {
    if (data) {
      reset({
        productname_en: data?.en?.title || "",
        description_en: data?.en?.description || "",
      });
    }
  }, [data, reset]);
  const handleTabChange = (newValue) => {
    setActiveTab(newValue);
  };

  const handleSaveClick = () => {
    const formData = getValues();
    formData.saveAction = "description_en";
    console.log("Description data to save:", formData);
    if (onSave) {
      onSave(formData, props?.curMenu);
      reset(formData); //保存后重置表单状态，isDirty 变为 false
    }
  };

  const handleReset = () => {
    reset();
  };

  //当isDirty 发生变化时，传递给上层 props.onDirtyChange(isDirty)
  React.useEffect(() => {
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, isDirty);
    }
  }, [isDirty, reset]);
  return (
    <SectionStyled id={props.id ? props.id : "section_productinfo"}>
      <SectionTitle title="Description - Provide a brief description of this product" />
      <Box
        sx={{
          padding: "10px",
          // height: "calc(100vh - 315px)",
          height: "calc(100vh - 255px)",
          overflowY: "auto",
          // background: "yellow",
        }}
      >
        <Box
          sx={{
            display: selectLanguage == "linkto_english" ? "block" : "none",
            pt: 2,
            pb: 2,
          }}
        >
          <Controller
            name="productname_en"
            control={control}
            rules={{ required: "Product name is required" }}
            render={({ field }) => (
              <CustomProductTextField
                {...field}
                label="English Product Name"
                fullWidth
                variant="outlined"
                placeholder="Enter the name of the product"
                error={!!errors.productname}
                helperText={errors.productname?.message?.toString()}
                required={true}
              />
            )}
          />
          <Controller
            name="description_en"
            control={control}
            rules={{ required: "Description is required" }}
            render={({ field }) => (
              <CustomProductTextField
                {...field}
                label="English Description"
                multiline
                rows={4}
                fullWidth
                variant="outlined"
                placeholder="Enter the description of the product"
                error={!!errors.description}
                helperText={errors.description?.message?.toString()}
                required={true}
                sx={{ marginTop: "5px" }}
              />
            )}
          />
        </Box>

        {/* Form Actions */}
      </Box>
      <CustomProductActionBottom>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSaveClick}
          disabled={!isDirty}
          sx={{ width: "120px", mt: 1 }}
        >
          Save
        </Button>
      </CustomProductActionBottom>
    </SectionStyled>
  );
}
